/**
 * Esquemas Zod — Módulo de Autenticación Primaria, MFA TOTP y OTP WhatsApp Rural (Paso 5.7)
 */

import { z } from 'zod';

export const loginCredencialesSchema = z.object({
  identificador: z
    .string()
    .trim()
    .min(4, { message: 'Ingresa tu correo electrónico o número celular' })
    .max(150),
  password: z
    .string()
    .min(6, { message: 'Ingresa tu contraseña (mínimo 6 caracteres)' })
    .max(128),
  rememberMe: z.boolean(),
});

export const mfaChallengeSchema = z.object({
  ticket_preauth: z.string().min(10, { message: 'Ticket de pre-autenticación inválido' }),
  codigo_totp: z
    .string()
    .trim()
    .regex(/^[0-9]{6}$/, { message: 'El código de verificación debe tener 6 dígitos numéricos' }),
});

export const otpWhatsappSolicitarSchema = z.object({
  telefono_movil: z
    .string()
    .trim()
    .regex(/^\+?[1-9][0-9]{7,14}$/, {
      message: 'Ingresa un número de celular válido (ej. +573104506789)',
    }),
});

export const otpWhatsappVerificarSchema = z.object({
  telefono_movil: z
    .string()
    .trim()
    .regex(/^\+?[1-9][0-9]{7,14}$/, { message: 'Número de celular inválido' }),
  codigo_otp: z
    .string()
    .trim()
    .regex(/^[0-9]{6}$/, { message: 'El código recibido por WhatsApp tiene 6 dígitos' }),
});

export type LoginCredencialesSchemaType = z.infer<typeof loginCredencialesSchema>;
export type MfaChallengeSchemaType = z.infer<typeof mfaChallengeSchema>;
export type OtpWhatsappSolicitarSchemaType = z.infer<typeof otpWhatsappSolicitarSchema>;
export type OtpWhatsappVerificarSchemaType = z.infer<typeof otpWhatsappVerificarSchema>;
